export enum HealthIdentificationEnum {
    cns = 1,
    healthPlan = 2,
}